import { CssBaseline } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import './App.css';
import { ApplicationError } from './components/UnexpectedError';
import { AuthProvider } from './contexts/AuthContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { router } from './router';
import { queryClient } from './services/queryClient';
import { reportApplicationError } from './utils/datadog';

const App: React.FC = () => (
  <ErrorBoundary
    fallback={<ApplicationError />}
    onError={(error, errorInfo) => {
      reportApplicationError(error, errorInfo.componentStack);
    }}
  >
    <AuthProvider>
      <SnackbarProvider>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <CssBaseline />
            <RouterProvider router={router} />
          </ThemeProvider>
        </QueryClientProvider>
      </SnackbarProvider>
    </AuthProvider>
  </ErrorBoundary>
);

export default App;
